import service from "../../../../../api/services";
import {
    InventoryData,
    PreparedDataReturn,
    TVerifyBulkInventoryPayload,
} from "../interface";

export const useCallApi = () => {

    //api for valid the data in inventory
    const verifyBulkInventory = async (data: PreparedDataReturn) => {
        const payload: TVerifyBulkInventoryPayload = {
            store_code: data.store_code,
            products: data?.product_details?.map((item) => item?.product_id)
        }
        try {
            const response =
                await service?.inventory?.bulkInventoryValid(payload);
            if (response?.status === 200 || response?.status === 201) {
                return response?.data?.data;
            }
        } catch (error) {
            console.log("error>>>>", error);
        }
    };

    //for upload the bulk inventory
    const handleBulkInventoryApi = async (data: PreparedDataReturn) => {
        try {
            const response = await service?.inventory?.bulkInventory(data);
        } catch (error) {
            console.log(">>>", error);
        }
    };

    return {
        handleBulkInventoryApi,
        verifyBulkInventory,
    };
};
